import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";
import { ApiUrl } from "../../../../api/api-url";
import Service from "../../../../api/api-service";
import { CONSTANT } from "../../../../constants/constant";
const service = new Service();

export const GET_LOOKUP_DISTRICT_OK = "GET_LOOKUP_DISTRICT_OK";
export const GET_LOOKUP_DISTRICT_ERR = "GET_LOOKUP_DISTRICT_ERR";

export const lookupDistrictAction = {
  getLookupDistrict,
};

function getLookupDistrictOk(payload) {
  return { type: GET_LOOKUP_DISTRICT_OK, payload };
}
function getLookupDistrictErr(payload) {
  return { type: GET_LOOKUP_DISTRICT_ERR, payload };
}

function getLookupDistrict(data) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.GetListDistrictAdm + "?pageIndex=1&pageSize=100000")
      .then((response) => {
        dispatch(getLookupDistrictOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}
